/* eslint-disable */
import axios from 'axios';
import Vue from 'vue';

import { SYSTEM_VARIABLE } from '../modules/Application';
import { getToken } from './token';
import { getSocketId } from './webSocket';
import { loadCache, setCache } from './cacheService';

export default function createAxios(version = 1) {
  const http = axios.create({
    baseURL: `${SYSTEM_VARIABLE.BASE_URL_API}/rpc/v${version}/`,
    headers: {
      Accept: 'application/json, text/plain, */*',
      'Accept-Language': 'pt_BR',
    },
  });

  http.interceptors.request.use(async (config) => ({
    ...config,
    headers: {
      ...config.headers,
      'Authorization-Compufacil': getToken(),
      'Socket-Id': getSocketId(),
    },
  }));

  http.interceptors.response.use(
    (response) => response,
    async (error) => {
      const token = await getToken();
      if (token) {
        Vue.$toast.open({
          message: error?.response?.data?.error_message || 'Erro inesperado',
          type: 'error',
          duration: 2000,
        });
      }
      return Promise.reject(error);
    },
  );

  http.postWithCache = async function(url, params = {}, cache = { key: null }, config = {}) {
    const cacheKey = cache.key != null ? cache.key : url;
    const data = await loadCache(cacheKey);

    if (data) {
      return Promise.resolve({ data });
    }

    const response = await http.post(url, params, config);
    setCache(cacheKey, response?.data);

    return response;
  };

  return http;
}
